"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createSvgIcon_1 = __importDefault(require("../createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { "fill-rule": "evenodd", d: "M12.75 6.707A4.386 4.386 0 0 1 16.247 5c1.328 0 2.45.583 3.185 1.318a4.5 4.5 0 0 1 0 6.364L12.75 19l-6.682-6.318a4.5 4.5 0 0 1 0-6.364C6.81 5.576 8.006 5 9.248 5c1.244 0 2.68.576 3.502 1.707Z", "clip-rule": "evenodd" }),
    react_1.default.createElement("path", { "fill-rule": "evenodd", d: "M12.75 12c-.001 0-.001 0 0 0Z", "clip-rule": "evenodd" })), 'HeartFilled', '4 4 17 16');
//# sourceMappingURL=index.js.map